import { sharedEffects } from 'shared-lib'
import { AccountSessionEffects } from './account-session/account-session.effects'
import * as customerEffects from './customer/customer.effects'
import * as searchKeyEffects from './search-key/search-key.effects'

export const effects = { ...searchKeyEffects, ...customerEffects, ...sharedEffects, AccountSessionEffects }
